/**
 * Destination d'une invitation acceptée → chemin du client.
 *
 * Le serveur renvoie `{ scopeType, organizationId, scopeId }` (contrat § 4 de la spec
 * onboarding fluide) et ne connaît pas les routes du client : les chemins ne sont écrits qu'ici,
 * en regard des routes réelles d'`App.jsx` (`/organisation/:organizationId`, `/equipes/:teamId`,
 * `/projets/:projectId/*`).
 */

const REPLI = '/projets';

/**
 * @param {{ scopeType?: string, organizationId?: string|null, scopeId?: string|null }|null|undefined} destination
 * @returns {string}
 */
export function cheminDeDestination(destination) {
  const { scopeType, organizationId, scopeId } = destination ?? {};
  if (scopeType === 'organization' && organizationId) {
    return `/organisation/${encodeURIComponent(organizationId)}`;
  }
  if (scopeType === 'team' && scopeId) return `/equipes/${encodeURIComponent(scopeId)}`;
  if (scopeType === 'project' && scopeId) return `/projets/${encodeURIComponent(scopeId)}`;
  return REPLI;
}
